<template>
  <v-card class="v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <div>
      <v-card-title style="padding: 28px">
      <v-row class="me-3 my-3">
        <v-row>
          <v-col cols="4" sm="4">
            <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              label="Search"
              style="max-width: 300px"
              variant="outlined"
              v-on:keyup.enter="loadData()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="m-0 d-flex align-center">
          <v-spacer></v-spacer>
          <v-card-actions>
              <v-btn
                variant="flat"
                id="menu-activator"
                :disabled="this.selected.length === 0 || checkItemMismatch"
                :color="this.selected.length === 0 || checkItemMismatch ? '' : 'primary'"
                class="ma-2"
              >
                TAKE ACTION
                <!-- <v-icon start icon="mdi-chevron-down"></v-icon> -->
              </v-btn>
              <v-menu activator="#menu-activator">
                <v-list>
                  <v-list-item
                    v-for="(item, index) in takeActionItems"
                    :key="index"
                    :value="index"
                  >
                    <v-list-item-title @click="takeAction(item)">{{
                      item
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-card-actions>
          <v-expansion-panels
            class="custom-control_outlined m-0"
            ref="filterPopupRef"
            readonly
            variant="outlined"
            style="max-width: 300px"
          >
            <v-expansion-panel variant="outlined" @click="handlefilterPopup">
              <v-expansion-panel-title
                >Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-row>
      </v-card-title>
    </div>
    <div>
      <v-layout column>
        <v-col cols="12" style="overflow: auto" class="p-0">
          <v-data-table
            hover
            density="compact"
            v-model="selected"
            :headers="headers"
            :items="table_data"
            show-select
            fixed-header
            height="100%"
            disable-pagination
            :hide-default-footer="true"
            class="elevation-1"
            :loading="loading"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait"
            return-object
          >
            <template v-slot:[`item.tag_number`]="{ item }">
              <span>{{ item.tag_number ? item.tag_number : "-" }}</span>
            </template>
            <template v-slot:[`item.item_issue`]="{ item }">
              <span>{{ item.item_issue ? item.item_issue : "-" }}</span>
            </template>
            <template #bottom></template>
          </v-data-table>
        </v-col>
      </v-layout>
      <v-container fluid>
        <v-row class="m-0">
          <v-col cols="12" class="d-flex justify-space-between gap-3">
            <div style="width: 6rem;">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                variant="underlined"
                label="Items per page"
                @update:modelValue="handlePageSizeChange"
              ></v-select>
            </div>
            <v-col cols="12" sm="4" class="PaddingItemPerPage d-flex justify-end">
              <v-pagination density="comfortable" elevation="2"
                v-model="page"
                :length="totalPages"
                total-visible="7"
                next-icon="mdi-menu-right"
                prev-icon="mdi-menu-left"
                active-color="bg-primary" 
                @update:modelValue="handlePageChange"
              >
              </v-pagination>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-putaway"
        v-model="filterPopup"
        persistent
        max-width="936px"
      >
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-combobox
                  clearable
                  color="primary"
                  v-model="filterClient"
                  :items="client_ids"
                  label="Client Id"
                  multiple
                  variant="outlined"
                  class="ma-2"
                  style="max-width: 300px"
                ></v-combobox>
              </v-col>
              <v-col>
                <v-combobox
                  clearable
                  color="primary"
                  v-model="filterLocation"
                  :items="consignor_locations"
                  label="Consignor Location"
                  multiple
                  variant="outlined"
                  class="ma-2"
                  style="max-width: 300px"
                ></v-combobox>
              </v-col>
              <v-col>
                <v-combobox
                  clearable
                  color="primary"
                  v-model="filterIssue"
                  :items="issues"
                  label="Issue"
                  multiple
                  variant="outlined"
                  class="ma-2"
                  style="max-width: 300px"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="text" color="normal" @click="filterPopup = false"
              >CANCEL</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              :color="(!this.filterClient?.length) && 
                (!this.filterLocation?.length) &&
                (this.filterIssue?.length) ? 'secondry' : 'primary'"
              @click="applyFilters()"
              :disabled="
                (!this.filterClient?.length) && 
                (!this.filterLocation?.length) &&
                (this.filterIssue?.length)
              "
              >APPLY FILTER(S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent.vue";
import { mixinHelper } from "../../../../mixins/mixin-helper.js";

export default {
  name: "PendingItemxResolution",
  mixins: [mixinHelper],
  data() {
    return {
      headerText: "Pending Item Resolution",
      table_data: [],
      selected: [],
      search: "",
      filterPopup: false,
      filterClient: [],
      filterLocation: [],
      filterIssue: [],
      client_ids: [],
      consignor_locations: [],
      issues: [],
      page: 1,
      pageSize: 100,
      pageSizes: [100, 200, 500],
      totalPages: 1,
      takeActionItems: [
        "Accept",
        "Write Off",
        "Send To Customer",
        "Send To Consignor",
      ],
      headers: [
        { title: "Tag ID", value: "tag_number" },
        { title: "Customer ID", value: "client_id" },
        { title: "Consignor Location", value: "location" },
        { title: "Issue", value: "item_issue" },
      ],
      loading: false,
    };
  },

  components: {
    HeaderComponent,
  },

  created() {
    this.loadData();
  },

  computed: {
    checkItemMismatch() {
      const isAnyNotPending = this.selected.some(
        (item) => item.item_issue == "Tag id Mismatch",
      );
      return isAnyNotPending;
    },
  },

  methods: {
    loadData(tab) {
      this.loading = true;
      this.selected = [];
      this.table_data = [];

      const params = this.getRequestParams(this.page, this.pageSize);
      const searchArray = [];
      if (this.search != "") {
        const parts = this.search.split(",");
        for (let i = 0; i < parts.length; i++) {
          searchArray.push(parts[i]);
        }
      }
      this.$httpSecured
        .get("/api/v1/items/pending_item_resolutions", {
          params: {
            search: searchArray,
            page: params["page"],
            per_page: params["size"],
          },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.items;
            this.totalPages = response.data.meta.total_pages;
            this.client_ids = response.data.items.map((x) => x.client_id).filter((value, index, self) => self.indexOf(value) === index);
            this.consignor_locations = response.data.items.map((x) => x.location).filter((value, index, self) => self.indexOf(value) === index);
            this.issues = response.data.items.map((x) => x.item_issue).filter((value, index, self) => self.indexOf(value) === index);
            this.filterClient = null;
            this.filterLocation = null;
            this.filterIssue = null;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    handlefilterPopup() {
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px",
      );
      this.filterPopup = true;
    },

    applyFilters() {
      this.loading = true;
      this.filterPopup = false;
      const params = {
        client_ids: this.filterClient,
        locations: this.filterLocation,
        item_issues: this.filterIssue,
        page: this.page,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get("/api/v1/items/pending_item_resolutions", { params: params })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.items;
            this.filterClient = "";
            this.filterLocation = "";
            this.filterIssue = "";
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    takeAction(item) {
      var selected_ids = this.selected.map((x) => x.id);
      var apiUrl = ''
      if (item == "Accept") {
         apiUrl = "/api/v1/items/accept";
      } else if (item == "Send To Customer" || item == "Send To Consignor") {
         apiUrl = "/api/v1/items/rejected?from_page=Item";
      } else if (item == "Write Off") {
         apiUrl = "/api/v1/items/write_off";
      }
      // else if (item == 'Send To Customer') {
      //   var apiUrl = "/api/v1/items/send_to_customer"
      // } else if (item == 'Send To Consignor') {
      //   var apiUrl = "/api/v1/items/send_to_consignor"
      // }

      this.$httpSecured
        .put(`${apiUrl}`, { ids: selected_ids })
        .then((response) => {
          if (response.data) {
            this.showAlert("success", response.data.message);
            this.loadData();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.loadData();
    },

    handlePageChange(value) {
      this.page = value;
      this.loadData();
    },
  },
};
</script>

<style>
.v-dialog__content:has(.filter-putaway) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}
</style>
